import { createEndpointRoute } from '@publishing-engine/domain/utils/endpoint-email-utils';

export const GetGlobalTemplatesByEvent = createEndpointRoute(
  '/email-templates/organizations/:organizationId/global/event/:eventName'
);
